module.exports = __webpack_public_path__ + "static/video1-89302d81ffc78292e1d73998df7e6b4c.mp4";